import Search from "../Search/components/Search"

export const FileAskQuestion = (props) => {
    return <>
        <Search hideMenu={true} fileChat={true} fileDetails={props.fileDetails} />
    </>
}